import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { usePageMeta } from '../hooks/usePageMeta';

const LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Longevity', to: '/longevity' },
  { label: 'Wellbeing', to: '/wellbeing' },
  { label: 'Resources', to: '/resources' },
  { label: 'My Login', to: '/my-login' },
];

export default function NotFound() {
  usePageMeta({
    title: 'Page not found | OVERALL WELLBEING',
    description: 'We couldn’t find that page. Explore the Essentials, the areas of life or the full library instead.',
    noindex: true,
    robots: 'noindex, nofollow',
    canonical: false,
  });

  return (
    <div className="w-full px-margin-mobile lg:px-margin py-space-3xl" data-testid="not-found-page">
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
        <span className="font-label-sm text-label-sm uppercase tracking-widest text-surface-tint font-bold mb-space-xs">Page not found</span>
        <h1 className="font-display-hero text-[32px] leading-[38px] md:text-headline-lg text-outline uppercase tracking-tight mb-space-md">
          This page has moved on
        </h1>
        <p className="font-body-lg text-body-lg text-on-surface-variant max-w-xl mb-space-xl">
          We couldn’t find what you were looking for. Here’s where you can pick things back up.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-space-sm">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`notfound-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
              className="inline-flex items-center gap-space-xs h-11 px-space-lg rounded-lg bg-surface-container-low text-outline font-label-md text-label-md uppercase tracking-wider hover:bg-surface-tint hover:text-on-primary transition-colors"
            >
              <span>{l.label}</span>
              <Icon name="arrow_forward" className="text-[16px]" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
